import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Portal } from '@angular/cdk/portal';
import { PopupState, PopupPosition } from '../models/popup.model';

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  private state$ = new BehaviorSubject<PopupState>({
    open: false,
    position: undefined,
  });
  private portal$ = new BehaviorSubject<any>(undefined);

  get state(): Observable<PopupState> {
    return this.state$.asObservable();
  }

  get portal(): Observable<Portal<any>> {
    return this.portal$.asObservable();
  }

  open(position: PopupPosition = PopupPosition.RIGHT) {
    this.state$.next({ open: true, position });
  }

  close() {
    this.state$.next({ open: false, position: undefined });
  }

  setPopupPortal(portal: Portal<any>) {
    this.portal$.next(portal);
  }

  clearPopupPortal() {
    this.portal$.next(undefined);
  }
}
